<template>
  <v-card v-if="!hide" class="eligibility-card" tile style="cursor: pointer;">
    <can I="read" a="Eligibility">
      <v-layout align-start justify-start row fill-height class="py-3">
        <v-flex xs2 class="text-xs-center">
          <v-layout align-center justify-start row fill-height>
            <v-flex xs3>
              <v-checkbox
                v-if="!isInvited"
                :input-value="isSelected"
                @click.stop="toggle(eligibility)"
                class="pl-2"
                color="primary"
              />
            </v-flex>
            <v-flex>
              <v-progress-circular
                :value="Number(eligibility.completion)"
                :size="90"
                :width="5"
                :rotate="-90"
                :color="eligibility.complete ? 'success' : 'warning'"
              >
                <v-avatar size="80">
                  <img
                    v-if="eligibility.profile && eligibility.profile.avatar"
                    :src="eligibility.profile.avatar"
                  />
                  <img v-else src="/img/missing/avatars/original.png" />
                </v-avatar>
                <v-avatar
                  v-if="featuredQualification"
                  size="40"
                  style="position: absolute; top: 45px; right: -15px;"
                >
                  <img
                    v-if="
                      !featuredQualification.institution || !featuredQualification.institution.logo
                    "
                    src="/img/missing/logos/institutions/original.png"
                  />
                  <img v-else :src="featuredQualification.institution.logo" />
                </v-avatar>
              </v-progress-circular>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs8>
          <v-card-title primary-title class="py-0" @click="$emit('click', eligibility.id)">
            <div>
              <div class="headline">
                {{ eligibility.profile.firstName }}
                <v-tooltip bottom v-if="eligibility.recentlyViewed">
                  <span slot="activator"
                    ><v-icon class="text-vertical-middle">mdi-eye</v-icon></span
                  >
                  <span>Recently Viewed</span>
                </v-tooltip>
                <v-tooltip bottom v-if="!eligibility.complete">
                  <span slot="activator"
                    ><v-icon class="text-vertical-middle" color="warning">mdi-account</v-icon></span
                  >
                  <span>Incomplete Profile</span>
                </v-tooltip>
              </div>
              <div v-if="featuredQualification" class="caption">
                {{ featuredQualification.qualificationTypeName }}
                <span v-if="featuredQualification.specialization">
                  in {{ featuredQualification.specialization }}
                </span>
              </div>
              <div
                v-if="featuredQualification && featuredQualification.institutionName"
                class="caption"
              >
                from {{ featuredQualification.institutionName }}
              </div>
            </div>
          </v-card-title>
        </v-flex>
        <v-flex xs3 class="text-xs-right caption mr-3">
          <span v-if="!isInvited">
            Updated {{ new Date(eligibility.profile.updatedAt) | inWords({ addSuffix: true }) }}
          </span>
          <span v-if="isInvited">
            Invited {{ new Date(eligibility.invite.createdAt) | inWords({ addSuffix: true }) }}
          </span>
        </v-flex>
      </v-layout>
      <can I="create" a="Invite">
        <CandidateQuickActionToolbar
          color="transparent"
          on-hover
          :candidate="eligibility"
          v-if="!isInvited"
        />
      </can>
    </can>
  </v-card>
</template>

<script>
// Components
import CandidateQuickActionToolbar from '@/components/applications_tracker/CandidateQuickActionToolbar'

// Helpers
import { mapGetters } from 'vuex'
import { byEndsAt, byLevels } from '@/sorting/ProfileQualification'
import _ from 'lodash'

export default {
  props: { eligibility: Object, phase: Object, canEdit: Boolean },
  components: { CandidateQuickActionToolbar },
  data() {
    return {
      hide: false,
    }
  },
  computed: {
    phaseQuestionnaireIds() {
      if (this.phase && this.phase.behaviors) {
        return this.phase.behaviors.map(b => (b.questionnaireId ? b.questionnaireId : null))
      }

      return null
    },
    featuredQualification() {
      if (_.get(this.eligibility, 'profile.profileQualification')) {
        // Use featured if available
        return this.eligibility.profile.profileQualification
      } else if (_.get(this.eligibility, 'profile.profileQualifications[0]')) {
        // Otherwise find featured in list
        const qualifications = JSON.parse(
          JSON.stringify(this.eligibility.profile.profileQualifications)
        )
        return qualifications.filter(pq => pq.featured)[0]
      } else {
        // Otherwise show none
        return null
      }
    },
    selected() {
      return this.$store.getters['admin/eligibilities/selected']
    },
    isSelected() {
      return this.selected.indexOf(this.eligibility.id) >= 0
    },
    anySelected() {
      return this.selected[0] != undefined
    },
    isInvited() {
      // Invite created after 2 weeks ago
      return (
        this.eligibility.invite &&
        this.eligibility.invite.createdAt &&
        new Date(this.eligibility.invite.createdAt) >
          new Date().getTime() - 14 * 24 * 60 * 60 * 1000
      )
    },
  },
  methods: {
    toggle(eligibility) {
      if (!this.isSelected) this.select(eligibility.id)
      else this.deselect(eligibility.id)
    },

    select(id) {
      if (this.isWithdrawn) {
        this.$store.dispatch('snackbarShow', 'No bulk action available')
        return
      }
      this.$store.commit('admin/eligibilities/select', id)
    },

    deselect(id) {
      this.$store.commit('admin/eligibilities/deselect', id)
    },
  },
}
</script>

<style>
.eligibility-card div.rating-wrapper > span > fieldset {
  position: relative;
  z-index: 100;
}

.eligibility-card {
  opacity: 0.8;
}
.eligibility-card:hover,
.eligibility-card:hover .application-tracker.quick-action-toolbar div.show-on-hover {
  opacity: 1;
}
</style>
